<template>
  <b-overlay
    :show="isLoading"
    rounded="sm"
  >
    <validation-observer
      ref="saveFormRef"
      #default="{invalid}"
    >
      <b-form>
        <b-row>
          <!-- Name Building -->
          <b-col cols="12">
            <b-form-group
              label="Tên lĩnh vực"
              label-for="name"
            >
              <template v-slot:label>
                Tên lĩnh vực <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Tên lĩnh vực"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="dataForm.name"
                  name="name"
                  placeholder="Nhập tên lĩnh vực"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label-for="status">
              <template v-slot:label>
                Trạng thái <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Trạng thái"
                rules="required"
              >
                <v-select
                  v-model="dataForm.status"
                  :options="statusOptions"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="Thứ tự"
              label-for="orderNo"
            >
              <b-form-input
                id="orderNo"
                v-model="dataForm.orderNo"
                name="orderNo"
                type="number"
                placeholder="Nhập thứ tự"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <div class="float-left">
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
                :disabled="invalid"
                @click="handleSaveData"
              >
                Lưu
              </b-button>
            </div>

          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BForm,
  BFormInvalidFeedback,
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BOverlay,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { showErrorToast, showSuccessToast } from '@/utils/notification'

export default {
  name: 'Form',
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormInvalidFeedback,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BOverlay,
    vSelect,
  },
  props: {
    dataForm: {
      type: Object,
      default: () => ({
        id: null,
        name: '',
        status: 1,
        orderNo: 1,
      }),
    },
    modalShow: {
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {
      isLoading: false,
      statusOptions: [
        { value: 1, label: 'Đang hoạt động' },
        { value: 0, label: 'Không hoạt động' },
      ],
      required,
    }
  },
  methods: {
    ...mapActions({
      saveData: 'factResearchFields/saveData',
    }),
    async handleSaveData(e) {
      e.preventDefault()
      const res = await this.saveData(this.dataForm)
      if (res.isSuccessful) {
        showSuccessToast(this, res.message)
        this.$emit('saveDataSuccess', true)
      } else {
        showErrorToast(this, 'Có lỗi xảy ra')
      }
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
  },
}
</script>
